import { isPerekrestokAppBrowser } from '@el5/native-api'
import { Tenants } from '@gp/base'

export const getTenant = (): Tenants =>
  isPerekrestokAppBrowser() ? Tenants.TCX : Tenants.TC5
